import { Building2, Hash, MapPin, User, Phone, Mail, ArrowLeft, FileText } from "lucide-react";
import LinknetInfo from "./LinknetInfo";

const sectionTitleClass =
  "text-base font-semibold text-gray-900 dark:text-gray-100 mb-4 pb-1.5 border-b border-gray-100 dark:border-gray-800";

export interface TenantInfo {
  tenantName: string;
  mallName: string;
  unit: string;
  alamat: string;
}

export interface PicData {
  picName: string;
  picPhone: string;
  picEmail: string;
  notes: string;
}

interface LinknetFormProps {
  tenantInfo: TenantInfo;
  pic: PicData;
  onPicChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDiscard: () => void;
  onSave: () => void;
  saving: boolean;
}

export default function LinknetForm({
  tenantInfo,
  pic,
  onPicChange,
  onDiscard,
  onSave,
  saving,
}: LinknetFormProps) {
  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-5">
      <div className="mb-5">
        <h2 className={sectionTitleClass}>Tenant Information</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <LinknetInfo
            label="Tenant Name"
            name="tenantName"
            value={tenantInfo.tenantName}
            icon={<Building2 className="w-4 h-4" />}
            disabled
          />
          <LinknetInfo
            label="Mall Name"
            name="mallName"
            value={tenantInfo.mallName}
            icon={<Building2 className="w-4 h-4" />}
            disabled
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LinknetInfo
            label="Unit"
            name="unit"
            value={tenantInfo.unit}
            icon={<Hash className="w-4 h-4" />}
            disabled
          />
          <LinknetInfo
            label="Alamat"
            name="alamat"
            value={tenantInfo.alamat}
            icon={<MapPin className="w-4 h-4" />}
            disabled
          />
        </div>
      </div>

      <div className="mb-5">
        <h2 className={sectionTitleClass}>PIC Information</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <LinknetInfo
            label="Nama PIC"
            name="picName"
            value={pic.picName}
            icon={<User className="w-4 h-4" />}
            onChange={onPicChange}
          />
          <LinknetInfo
            label="No HP"
            name="picPhone"
            value={pic.picPhone}
            type="tel"
            icon={<Phone className="w-4 h-4" />}
            onChange={onPicChange}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LinknetInfo
            label="Email"
            name="picEmail"
            value={pic.picEmail}
            type="email"
            icon={<Mail className="w-4 h-4" />}
            onChange={onPicChange}
          />
          <LinknetInfo
            label="Notes"
            name="notes"
            value={pic.notes}
            icon={<FileText className="w-4 h-4" />}
            onChange={onPicChange}
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-100 dark:border-gray-800">
        <button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
}
